<template>
  <div>
    <b-button
      block
      :to="{ name: 'rota-dashboard'}"
      variant="custom"
      class="logo__button">
      <div class="srn_logo">
        <!-- <img class="infos" src="../img/IMG_5640.JPG"> -->
        <b-img src="https://cdn-griffo.nyc3.cdn.digitaloceanspaces.com/SRN/g256.png" class="logoGriffo" fluid alt="Responsive image"></b-img>
      </div>
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'BarraLateralLogo',
}

</script>

<style lang="scss" scoped>
@import "@/scss/colors.scss";

.logo__button {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 1.65rem;
  color: $cor-fonte-clara;

  &__text {
    margin-left: .5rem;
    color: $cor-fonte-clara;
  }
}

.logoGriffo{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: .5rem;
  padding-bottom: .5rem;
}
</style>
